import React, { Suspense } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { IntlProvider } from 'react-intl';
import { LoadingScreen, PrivateRoute } from 'components/Atoms';
import { PrivateLayout } from 'components/Templates';
import renderRoutes from 'routers/render';
import * as routeName from 'routers/route-name';

import { selectLanguage } from 'states/common/selectors';
import messages_en from 'translations/en.json';
import messages_br from 'translations/br.json';
import messages_fr from 'translations/fr.json';
import messages_sp from 'translations/sp.json';
import { useSelector } from 'react-redux';

import { QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import queryClient from 'utilities/queryClient';
import useProfile from 'hooks/useProfile';
import withPendo from 'hooks/withPendo';
import withPushLapScript from 'hooks/withPushLapScript';
import { useBeforeRender } from 'hooks/useBeforeRender';
import Maintenance from 'components/Pages/Maintenance';
import {
  defaultRichTextElements,
} from 'utilities/intlRichText';

const messages = {
  en: messages_en,
  br: messages_br,
  fr: messages_fr,
  sp: messages_sp,
};

const languageBrowser = navigator.language?.split(/[-_]/)[0] || 'en';

const Routers = () => {
  //service
  const { data: userInfo } = useProfile();

  return (
    <Router>
      <Suspense fallback={<LoadingScreen />}>
        <Switch>
          {renderRoutes(false, userInfo)}
          <PrivateRoute path="/" name={routeName.HOME}>
            <PrivateLayout userInfo={userInfo} />
          </PrivateRoute>
        </Switch>
      </Suspense>
    </Router>
  );
};

function App() {
  // Handle subdomain
  const languageLo = useSelector(selectLanguage());
  const language = languageLo || languageBrowser;
  const isMaintenanceMode = process.env.REACT_APP_MAINTENANCE_MODE;

  if (isMaintenanceMode) {
    return <Maintenance />;
  }

  useBeforeRender(() => {
    window.addEventListener('error', (e) => {
      if (e) {
        const resizeObserverErrDiv = document.getElementById(
          'webpack-dev-server-client-overlay-div'
        );
        const resizeObserverErr = document.getElementById(
          'webpack-dev-server-client-overlay'
        );
        if (resizeObserverErr)
          resizeObserverErr.className = 'hide-resize-observer';
        if (resizeObserverErrDiv)
          resizeObserverErrDiv.className = 'hide-resize-observer';
      }
    });
  }, []);

  const AppWithPushLap = withPushLapScript(Routers);
  return (
    <>
      <QueryClientProvider client={queryClient}>
        <IntlProvider
          locale={language}
          messages={messages[language]}
          defaultRichTextElements={defaultRichTextElements}
        >
          <AppWithPushLap />
        </IntlProvider>
      </QueryClientProvider>
    </>
  );
}

export default withPendo(App);
